import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

/** A labelled switch with description used across the config settings pages. */
export function ToggleRow({
  label,
  description,
  checked,
  onChange,
  locked,
  disabled,
}: {
  label: string;
  description?: string;
  checked: boolean;
  onChange?: (v: boolean) => void;
  /** Read-only, always-on control (e.g. "Khám dịch vụ"). */
  locked?: boolean;
  /** Temporarily unavailable because a parent toggle is off. */
  disabled?: boolean;
}) {
  const off = locked || disabled;
  return (
    <label
      className={cn(
        "flex items-start gap-3 py-3",
        off ? "cursor-default" : "cursor-pointer",
        disabled && "opacity-50"
      )}
    >
      <Checkbox
        className="mt-0.5"
        checked={checked}
        disabled={off}
        onCheckedChange={(v) => onChange?.(v === true)}
      />
      <span className="min-w-0">
        <span className="text-sm font-medium text-foreground">{label}</span>
        {description && <span className="block text-sm text-muted-foreground">{description}</span>}
      </span>
    </label>
  );
}
